import cn from "classnames"
import Icon from "components/Icon"
import Image from "components/Image"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import richText from "utilities/richText"

function Item({ item }) {
  return (
    <StoryblokVisualEditor story={item}>
      <div className="gap-10 py-6 first:pt-0 last:pb-0 lg:flex">
        <div>
          <Icon icon={item.icon} className="mb-4 lg:mb-0" />
        </div>
        <div>
          <h3 className="pb-3.5 font-secondary text-m2 font-medium text-teal-dark lg:text-l1">{item.title}</h3>
          {richText(item.content)}
        </div>
      </div>
    </StoryblokVisualEditor>
  )
}

export default function ProgramInfo({ blok }) {
  return (
    <section>
      <div className="flex flex-col gap-8 lg:flex-row xl:gap-18">
        {blok?.image?.filename ? (
          <div className="relative w-full lg:basis-5/12 xl:basis-1/2">
            <Image
              src={blok?.image?.filename}
              alt={blok?.image?.alt}
              placeholder={blok?.image?.blurDataURL ? "blur" : "empty"}
              blurDataURL={blok?.image?.blurDataURL}
              width={585}
              height={250}
              className="z-10 h-full max-h-80 w-full object-cover sm:max-h-96 lg:max-h-none"
            />
          </div>
        ) : null}
        <div
          className={cn("flex flex-col divide-y divide-gray-mid pb-12 lg:py-18", {
            "mx-auto w-full max-w-screen-xl px-6 pt-12": !blok?.image?.filename,
            "max-w-2xl px-6 lg:basis-7/12 lg:pl-0 lg:pr-12 xl:basis-1/2 xl:pr-24": blok?.image?.filename,
          })}
        >
          {blok?.items?.map((item) => (
            <Item item={item} key={item._uid} />
          ))}
        </div>
      </div>
    </section>
  )
}
